import React from 'react';

export const ReferencesSection: React.FC = React.memo(() => {
  return (
    <div className="references">
      <h3>References</h3>
      <ol>
        <li id="reference-1">
          <a 
            href="https://pubmed.ncbi.nlm.nih.gov/32251974/" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            Fenley H, Voorman M, Dove JT, Greene JS. Predicting pediatric tracheal airway size from anthropomorphic measurements. Int J Pediatr Otorhinolaryngol. 2020 Jul;134:110020. doi: 10.1016/j.ijporl.2020.110020. PMID: 32251974.
          </a>
        </li>
        <li id="reference-2">
          <a 
            href="https://scholar.google.com/scholar_lookup?title=Endotracheal+intubation&author=EK+Motoyama&publication_year=1990&pages=272-275" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            Motoyama EK. Endotracheal intubation. In: Motoyama EK, Davis PJ, eds. Smith's Anesthesia for Infants and Children. 5th ed. CV Mosby Co; 1990:272–275.
          </a>
        </li>
        <li id="reference-3">
          <a 
            href="https://pubmed.ncbi.nlm.nih.gov/9066329/" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            Khine HH, Corddry DH, Kettrick RG, et al. Comparison of cuffed and uncuffed endotracheal tubes in young children during general anesthesia. Anesthesiology. 1997;86(3):627-631. doi:10.1097/00000542-199703000-00015
          </a>
        </li>
        <li id="reference-4">
          <a 
            href="https://pubmed.ncbi.nlm.nih.gov/18184241/" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            Duracher C, Schmautz E, Martinon C, et al. Evaluation of cuffed tracheal tube size predicted using the Khine formula in children. Paediatr Anaesth. 2008;18(2):113-118. doi:10.1111/j.1460-9592.2007.02382.x
          </a>
        </li>
        <li id="reference-5">
          <a 
            href="https://pubmed.ncbi.nlm.nih.gov/36796213/" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            Zhuang PE, Lu JH, Wang WK, Cheng MH. A new formula based on height for determining endotracheal intubation depth in pediatrics: A prospective study. J Clin Anesth. 2023;86:111079. doi:10.1016/j.jclinane.2023.111079
          </a>
        </li>
        <li id="reference-6">
          <a 
            href="https://pubmed.ncbi.nlm.nih.gov/19178655/" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            Eipe N, Barrowman N, Writer H, Doherty D. A weight-based formula for tracheal tube size in children. Paediatr Anaesth. 2009;19(4):343-348. doi:10.1111/j.1460-9592.2008.02916.x
          </a>
        </li>
      </ol>
    </div>
  );
});